import type * as React from "react";
import { Box } from "@mui/material";
import type { SxProps, Theme } from "@mui/material/styles";
import Footer from "../Footer";
import { COLORS } from "../../Theme/colors";
import Header from "../Header";

interface GradientFramedLayoutProps {
  children: React.ReactNode;
  showHeader?: boolean;
  showFooter?: boolean;
  showNav?: boolean;
  makeLogoClickable?: boolean;
  rootSx?: SxProps<Theme>;
}

const GradientFramedLayout: React.FC<GradientFramedLayoutProps> = ({
  children,
  showHeader = false,
  showFooter = true,
  showNav = true,
  makeLogoClickable = true,
  rootSx
}) => {
  return (
    <Box
      sx={{
        alignItems: "center",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        height: "100%",
        background: `linear-gradient(to bottom, #F2F7FB, ${COLORS.WHITE})`,
        minHeight: "100vh",
        position: "relative",
        width: "100%",
        fontFamily: "Inter, sans-serif",
        "& .MuiInputBase-root": {
          fontFamily: "Inter, sans-serif",
          color: COLORS.DARK_GRAY,
          "& .MuiInputBase-input": {
            fontFamily: "Inter, sans-serif",
            color: COLORS.DARK_GRAY
          }
        },
        "& .MuiFormHelperText-root, .MuiFormLabel-root": {
          fontFamily: "Inter, sans-serif"
        },
        ...rootSx
      }}
    >
      {showHeader && (
        <Header showNav={showNav} makeLogoClickable={makeLogoClickable} />
      )}
      <Box
        component="main"
        sx={{
          flex: "1 0 auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%"
        }}
      >
        {children}
      </Box>
      {showFooter && <Footer />}
    </Box>
  );
};

export default GradientFramedLayout;
